import { render, staticRenderFns } from "./NotifyFinance.vue?vue&type=template&id=6bc095c8"
import script from "./NotifyFinance.vue?vue&type=script&lang=js"
export * from "./NotifyFinance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports